import 'bootstrap';
import objectFitImages from 'object-fit-images';
import widont from 'widont';

import Layout from './layout';
import Navigation from './navigation';
import Whiteboard from './whiteboard';
import ResponsiveBootstrapToolkit from './vendor/bootstrap-toolkit';
import Misc from './misc.js';
import Fullpage from './fullpage.js';
import Newsletter from './newsletter.js';

global.$ = global.jQuery = $;
global.ResponsiveBootstrapToolkit = ResponsiveBootstrapToolkit;
global.widont = widont;

global.objectFitImages = objectFitImages;
global.Misc = new Misc();
global.Fullpage = Fullpage;
global.Layout = new Layout();
global.Navigation = new Navigation();
global.Whiteboard = new Whiteboard();
global.Newsletter = new Newsletter();